export default __webpack_public_path__ + "static/media/CNo.60-1.2aafaa0b.jpg";